(function($) {
    $(document).on('gform_confirmation_loaded', function () {
        jQuery(window).scrollTop(0)
    });
})(jQuery)
